import * as React from "react";
const CivilMilitaryCoordinationIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 47.96 48",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.04 6.52a4.48 4.48 0 1 0 8.96 0A4.227 4.227 0 0 0 15.73 5H7.31a4.227 4.227 0 0 0-.27 1.52zm10.98 8.58-1.15 1.15-1.32 1.32-8.41 8.41H17v-7.33a8.053 8.053 0 0 1 0 11.74v-1.41H6v1.45a8.059 8.059 0 0 1 0-11.82v4.27l6.37-6.37 1.47-1.47 1.37-1.37a11.278 11.278 0 0 0-3.73-.63A11.475 11.475 0 0 0 6 34.6l.022.011A.493.493 0 0 0 6.5 35h10a.493.493 0 0 0 .482-.411L17 34.58a11.461 11.461 0 0 0 1.02-19.48zm12.94 19.44c.017.01.036.017.053.026A.494.494 0 0 0 31.5 35h10a.496.496 0 0 0 .492-.459 11.477 11.477 0 1 0-11.032-.001zM42 30.349V18.61a8.05 8.05 0 0 1 0 11.738zM30.96 18.61l.04-.034v11.808l-.04-.034a8.053 8.053 0 0 1 0-11.74zM8 3h7a1.023 1.023 0 0 0 1-1.04v-.915a1.022 1.022 0 0 0-1.11-1.04l-7 .811A1.032 1.032 0 0 0 7 1.856v.104A1.023 1.023 0 0 0 8 3z",
  style: {
    fill: "#000"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36.5,
  cy: 6.5,
  r: 4.5,
  style: {
    fill: "#000"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.577 37.443a1.51 1.51 0 0 0-2.135 2.139L16.858 41H1.545a1.5 1.5 0 1 0 0 3h15.313l-1.416 1.418a1.51 1.51 0 1 0 2.135 2.139l3.98-3.988a1.514 1.514 0 0 0 0-2.138zM46.455 41H31.142l1.416-1.418a1.51 1.51 0 1 0-2.135-2.139l-3.98 3.988a1.514 1.514 0 0 0 0 2.138l3.98 3.988a1.51 1.51 0 1 0 2.135-2.139L31.142 44h15.313a1.5 1.5 0 1 0 0-3z",
  style: {
    fill: "#000"
  }
})));
export default CivilMilitaryCoordinationIcon;